<template>
  <v-app>

    <v-main class="page">

      <v-container
        max-width="1200"
        class="page-container"
      >

        <!-- ===================================================
             BOOK / HERO
        ==================================================== -->

        <section class="hero">

          <div class="hero-container">

            <div class="hero-book">

              <v-img
                :src="Seclogo"
                class="book-image"
              />

              <div class="book-link-wrapper">

                <a
                  href="https://www.behrs.de/person/thomas-schermuly/3062"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="hero-button"
                >

                  <span>
                    Buch jetzt erwerben
                  </span>

                  <v-icon size="18">
                    mdi-arrow-right
                  </v-icon>

                </a>

              </div>

            </div>

          </div>

        </section>


        <!-- ===================================================
             VERANSTALTUNGEN / SCHULUNGEN
        ==================================================== -->

        <section class="services">

          <div class="content">

            <div class="section-title">

              <h2>
                Schulungen & Veranstaltungen
              </h2>

              <div class="section-line"></div>

            </div>


            <div class="services-list">


              <!-- =================================================
                   1
              ================================================== -->

              <div class="service">

                <div class="service-card">

                  <h2 class="headline">
                    Feuerwache 3 in Wetzlar (Büblingshausen) Hygieneschulung für den Tag der Offenen Tür
                  </h2>

                  <div class="image-wrapper">

                    <v-img
                      :src="Feuerwehr"
                      class="rounded"
                      cover
                    />

                  </div>

                </div>

              </div>


              <!-- =================================================
                   2
              ================================================== -->

              <div class="service">

                <div class="service-card">

                  <h2 class="headline">
                    Tagesseminar für Hygienebeauftragte für die Gemeinschaftsverpflegung in Wetzlar
                  </h2>

                  <div class="image-wrapper">

                    <v-img
                      :src="Group"
                      class="rounded"
                      cover
                    />

                  </div>

                </div>

              </div>


              <!-- =================================================
                   3
              ================================================== -->

              <div class="service">

                <div class="service-card">

                  <h2 class="headline">
                    Tagesseminar für Hygienebeauftragte für die Gemeinschaftsverpflegung in Wetzlar
                  </h2>

                  <div class="image-wrapper">

                    <v-img
                      :src="Group2"
                      class="rounded"
                      cover
                    />

                  </div>

                </div>

              </div>


              <!-- =================================================
                   4
              ================================================== -->

              <div class="service">

                <div class="service-card">

                  <h2 class="headline">
                    Hardt-Großküchen-Spültechnik Schulung der Servicetechniker (Urkunde)
                  </h2>

                  <div class="image-wrapper">

                    <v-img
                      :src="Urkunde"
                      class="rounded"
                      cover
                    />

                  </div>

                </div>

              </div>

            </div>

          </div>

        </section>

      </v-container>

    </v-main>

  </v-app>
</template>


<script setup>

import Seclogo from "../assets/Book.png"
import Feuerwehr from "../assets/Feuerwehr.jpeg"
import Group from "../assets/Group.jpeg"
import Group2 from "../assets/Group2.jpeg"
import Urkunde from "../assets/Zerti.jpeg"

</script>


<style scoped>

/* ============================================================
   GLOBAL
============================================================ */

:global(html),
:global(body) {

  margin: 0;
  padding: 0;

  width: 100%;

  overflow-x: hidden;

  font-family:
    Arial,
    Helvetica,
    sans-serif;

  background: #f5f5f3;

  color: #111111;
}


/* ============================================================
   PAGE
============================================================ */

.page {

  width: 100%;

  min-height: 100vh;

  background: #f5f5f3;
}


/* ============================================================
   PAGE CONTAINER
============================================================ */

.page-container {

  width: 100%;

  padding-top: 0;
  padding-bottom: 0;

}


/* ============================================================
   HERO
============================================================ */

.hero {

  width: 100%;

  position: relative;

  background: #f5f5f3;

  padding-top: 55px;

  padding-bottom: 30px;

}


/* ============================================================
   HERO CONTAINER
============================================================ */

.hero-container {

  width: calc(100% - 116px);

  max-width: 1190px;

  margin: 0 auto;

  position: relative;
}


/* ============================================================
   BOOK
============================================================ */

.hero-book {

  width: 100%;

  display: flex;

  flex-direction: column;

  align-items: center;
}


/* ============================================================
   BOOK IMAGE
============================================================ */

.book-image {

  width: 100%;

  max-width: 1000px;

  margin: 0 auto;

  display: block;

  background: transparent;
}


/* ============================================================
   BOOK LINK / HERO BUTTON
============================================================ */

.book-link-wrapper {

  display: flex;

  justify-content: center;

  margin-top: 25px;
}


.hero-button {

  width: 232px;

  height: 41px;

  padding:
    0 16px 0 19px;

  background:
    var(--green);

  color: #ffffff;

  display: flex;

  align-items: center;

  justify-content: space-between;

  font-size: 11px;

  font-weight: 700;

  text-decoration: none;

  transition:
    0.2s ease;
}


.hero-button:hover {

  background:
    var(--green-dark);

  color: #ffffff;

  transform:
    translateY(-1px);
}


/* ============================================================
   SERVICES
============================================================ */

.services {

  width: 100%;

  padding-top: 45px;

  padding-bottom: 65px;

  background: #ffffff;
}


/* ============================================================
   CONTENT
============================================================ */

.content {

  width: calc(100% - 116px);

  max-width: 1190px;

  margin: 0 auto;
}


/* ============================================================
   SECTION TITLE
============================================================ */

.section-title {

  text-align: center;

  margin-bottom: 40px;
}


.section-title h2 {

  margin: 0;

  color: #111111;

  font-size: 22px;

  font-weight: 700;

  line-height: 1.2;
}


.section-line {

  width: 32px;

  height: 2px;

  margin:
    8px auto 0;

  background:
    var(--green);
}


/* ============================================================
   SERVICES LIST
============================================================ */

.services-list {

  display: grid;

  grid-template-columns:
    repeat(2, 1fr);

  column-gap: 28px;

  row-gap: 45px;

  width: 100%;
}


/* ============================================================
   SERVICE
============================================================ */

.service {

  min-width: 0;

  padding: 0;

}


/* ============================================================
   SERVICE CARD
============================================================ */

.service-card {

  width: 100%;

  height: 100%;

  display: flex;

  flex-direction: column;

  align-items: center;

  text-align: center;

}


/* ============================================================
   HEADLINE
============================================================ */

.headline {

  position: relative;

  display: flex;

  align-items: center;

  justify-content: center;

  width: 100%;

  min-height: 72px;

  margin: 0 0 18px;

  padding:
    0 20px 14px;

  box-sizing: border-box;

  color: #111111;

  font-size: 14px;

  line-height: 1.4;

  font-weight: 700;

  letter-spacing: -0.2px;

}


/* ============================================================
   GREEN LINE
============================================================ */

.headline::after {

  content: "";

  position: absolute;

  left: 50%;

  bottom: 0;

  transform:
    translateX(-50%);

  width: 32px;

  height: 2px;

  background:
    var(--green);
}


/* ============================================================
   IMAGE WRAPPER
============================================================ */

.image-wrapper {

  position: relative;

  width: 100%;

  overflow: hidden;

  border-radius: 10px;

  background: #ffffff;

  box-shadow:
    0 5px 20px rgba(0,0,0,0.08);

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}


/* ============================================================
   IMAGE
============================================================ */

.image-wrapper :deep(.v-img) {

  width: 100%;

  border-radius: 10px;

  display: block;

}


/* ============================================================
   HOVER
============================================================ */

.image-wrapper:hover {

  transform:
    translateY(-2px);

  box-shadow:
    0 10px 28px rgba(0,0,0,0.12);
}


/* ============================================================
   ROUNDED
============================================================ */

.rounded {

  border-radius: 10px;
}


/* ============================================================
   TABLET
============================================================ */

@media (max-width: 1200px) {

  .hero-container,
  .content {

    width:
      calc(100% - 50px);

  }


  .services-list {

    column-gap: 22px;

    row-gap: 38px;

  }


  .headline {

    font-size: 13.5px;

  }

}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 760px) {

  :global(html),
  :global(body) {

    width: 100%;

    max-width: 100%;

    overflow-x: hidden !important;

  }


  .page {

    width: 100%;

    max-width: 100%;

    overflow-x: hidden;

  }


  .page-container {

    width: 100% !important;

    max-width: 100% !important;

    padding: 0 !important;

  }


  /* ----------------------------------------------------------
     HERO
  ---------------------------------------------------------- */

  .hero {

    width: 100%;

    padding-top: 30px;

    padding-bottom: 35px;

    background:
      #f5f5f3;
  }


  .hero-container {

    width:
      calc(100% - 40px);

    max-width: none;

    margin: 0 auto;

  }


  /* ----------------------------------------------------------
     BOOK IMAGE
  ---------------------------------------------------------- */

  .book-image {

    width: 100% !important;

    max-width: 100% !important;

    height: auto;

    margin: 0 auto;

  }


  /* ----------------------------------------------------------
     BUTTON
  ---------------------------------------------------------- */

  .book-link-wrapper {

    margin-top: 22px;

  }


  .hero-button {

    width: 100%;

    max-width: 250px;

    height: 46px;

    padding:
      0 17px;

    font-size: 11px;

  }


  /* ----------------------------------------------------------
     SERVICES
  ---------------------------------------------------------- */

  .services {

    width: 100%;

    padding-top: 55px;

    padding-bottom: 45px;

    background:
      #ffffff;
  }


  .content {

    width:
      calc(100% - 30px);

    max-width: none;

    margin: 0 auto;

  }


  /* ----------------------------------------------------------
     TITLE
  ---------------------------------------------------------- */

  .section-title {

    margin-bottom: 35px;

  }


  .section-title h2 {

    font-size: 22px;

    line-height: 1.2;

  }


  /* ----------------------------------------------------------
     LIST
  ---------------------------------------------------------- */

  .services-list {

    width: 100%;

    display: grid;

    grid-template-columns:
      1fr;

    row-gap: 40px;

  }


  /* ----------------------------------------------------------
     SERVICE
  ---------------------------------------------------------- */

  .service {

    width: 100%;

    min-height: 0;

    padding: 0;

  }


  .service-card {

    width: 100%;

  }


  /* ----------------------------------------------------------
     HEADLINE
  ---------------------------------------------------------- */

  .headline {

    width: 100%;

    min-height: 0;

    margin-bottom: 18px;

    padding:
      0 8px 14px;

    font-size: 14px;

    line-height: 1.4;

  }


  .headline::after {

    width: 30px;

    height: 2px;

  }


  /* ----------------------------------------------------------
     IMAGE
  ---------------------------------------------------------- */

  .image-wrapper {

    width: 100%;

    border-radius: 10px;

    box-shadow:
      0 5px 20px rgba(0,0,0,0.08);

  }


  .image-wrapper:hover {

    transform: none;

    box-shadow:
      0 5px 20px rgba(0,0,0,0.08);

  }


  .rounded {

    border-radius: 10px;

  }

}


/* ============================================================
   VERY SMALL DEVICES
============================================================ */

@media (max-width: 450px) {

  .hero {

    padding-top: 20px;

    padding-bottom: 30px;

  }


  .hero-container {

    width:
      calc(100% - 30px);

  }


  .book-link-wrapper {

    margin-top: 18px;

  }


  .hero-button {

    width: 100%;

    max-width: 240px;

    height: 44px;

    font-size: 10px;

  }


  .services {

    padding-top: 45px;

    padding-bottom: 35px;

  }


  .content {

    width:
      calc(100% - 24px);

  }


  .section-title {

    margin-bottom: 30px;

  }


  .section-title h2 {

    font-size: 20px;

  }


  .services-list {

    row-gap: 32px;

  }


  .headline {

    font-size: 13px;

    line-height: 1.4;

    padding:
      0 6px 13px;

    margin-bottom: 16px;

  }


  .headline::after {

    width: 28px;

  }


  .image-wrapper {

    border-radius: 8px;

  }


  .rounded {

    border-radius: 8px;

  }

}


/* ============================================================
   ACCESSIBILITY
============================================================ */

.hero-button:focus-visible {

  outline:
    2px solid
    var(--green);

  outline-offset: 3px;
}


/* ============================================================
   REDUCED MOTION
============================================================ */

@media (prefers-reduced-motion: reduce) {

  .hero-button,
  .image-wrapper {

    transition: none;

  }

}

</style>